<template>
  <div class="home">
    <navbar :is-active="5"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/id-productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Client/id-clientes" class="tab">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Client/id-ventas" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Ventas</p>
            </div>
          </router-link>
          <router-link to="/Client/id-sucursales" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-cart"></i>
            </div>
            <div class="tab__text">
              <p>Sucursales</p>
            </div>
          </router-link>
          <router-link to="/Client/id-mapa-validacion" class="tab">
            <div class="tab__icon">
              <i class="fas fa-map-marked-alt"></i>
            </div>
            <div class="tab__text">
              <p>Mapa de Validación</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Sucursales</h2>
        </div>
        <div class="page__filters">
          <input
              type="text"
              placeholder=" Desde esta Fecha "
              onfocus="(this.type='date')"
              v-model="desde"
              style="width: 15%"


          />
          <input
              type="text"
              placeholder=" Hasta esta Fecha "
              onfocus="(this.type='date')"
              v-model="hasta"
              style="width: 15%"
              class="mob"
          />
          <button @click="search"  style="background: #ff3128; border: none; border-radius:1rem; padding: 0 1rem;">
            <span style="color:white; font-weight:bold;">Buscar</span>
          </button>
        </div>
        <div v-if="this.branchoffice">
          <div class="accountant">
            <div class="accountant_number">
              <h1 style="color: #44ba7d">{{branchoffice.total_sucursales}}</h1>
              <p>Total sucursales</p>
            </div>
            <div class="accountant_number">
              <h1 style="color: #000000">{{branchoffice.promedio_sucursal}}</h1>
              <p>Promedio de ventas por sucursal</p>
            </div>
            <div class="accountant_number">
              <h2 style="font-size: 50px; color: #44ba7d">{{branchoffice.sucursal_mas_ventas}}</h2>
              <p>sucursal con más cantidad de ventas</p>
            </div>
            <div class="accountant_number">
              <h2 style="font-size: 50px; color: #ff3128">{{branchoffice.sucursal_menos_ventas}}</h2>
              <p>sucursal con menos cantidad de ventas</p>
            </div>
          </div>

          <div class="report">
            <div class="simple_table">
              <div class="page__table">
                <div class="table-headers">
                  <p>Raking</p>
                  <p>Cliente B2B</p>
                  <p>Cantidad vendido</p>
                </div>
                <div class="table-body">
                  <div class="data" v-for="(branch, key) of branchoffice.ranking_sucursales" :key="branch.id">
                    <div class="data">
                      <p>{{ key + 1 }}</p>
                      <p>{{ branch.sucursal }}</p>
                      <p>{{ branch.ventas }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 26%; padding-top: 3%; padding-left: 2%;">
              <BarChart :header="header"  :body="body"/>
            </div>
          </div>
        </div>
        <p v-else class="indicador">{{mensaje}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import OpenArrow from '@/components/OpenArrow.vue'
  import HiddenArrow from '@/components/HiddenArrow.vue'
  import BarChart from '@/components/BarChart'

  export default {
    name: 'IDSucursales',
    components: {
      Navbar,
      OpenArrow,
      HiddenArrow,
      BarChart
    },
    data() {
      return {
        company_name: localStorage.getItem('company_name'),
        branchoffice: null,
        mensaje: 'Ingrese un rango de fechas',
        desde: '',
        hasta: '',
        fecha: '',
        usuario: '',
        list: [],
        header: [],
        body: [],
      }
    },
    mounted() {
      this.basicInfo()
      if (localStorage.getItem('token')) {
        this.company_name = localStorage.getItem('company_name');
      } else {
        this.$router.push('/login')
      }
    },
    methods: {
      search: function() {
        if(""){
          this.mensaje
        }else{
          clearTimeout(this.timeout);
          var self = this;
          this.timeout = setTimeout(function () {
            let paramSearch = {
              desde: self.desde,
              hasta: self.hasta,
            }
            this.getall(paramSearch)
          }.bind(this), 500);
        }
      },
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      getall( paramSearch = {} ) {
        this.header=[]
        this.body=[]
        var data = {
          desde:  (paramSearch.desde) ? paramSearch.desde : null,
          hasta:  (paramSearch.hasta) ? paramSearch.hasta : null,
          company_id: localStorage.getItem('company_id')
        }
        let result = axios.post('general/indicator/bybranchoffices',data, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }).then(res => {
          this.branchoffice = res.data.data
          this.branchoffice.anual_sucursales.forEach(item =>{
            this.header.push(item.sucursal)
            this.body.push(item.total)
          })

          console.log('#########################')
          console.log(res.data.data)
        })
      },
      basicInfo() {
        this.usuario = localStorage.getItem('usuario')
        this.list = JSON.parse(localStorage.getItem('getListOfMenu'))
        this.getDate()
      },
      getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        var fechaNum = date.getDate()
        var mes_name = date.getMonth()

        this.fecha =
          dias[date.getDay() - 1] +
          ' ' +
          this.zeroFill(fechaNum, 2) +
          ' de ' +
          meses[mes_name]
      },
      zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      }
    }
  }
</script>

<style scoped>
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }
  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__sidebar,
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }
  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }
  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }
  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }
  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }
  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }
  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }
  .body__containt {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }
  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }
  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }
  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 2%;
  }
  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #262626;
  }
  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }
  .body__containt .page__table .table-headers {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }
  .body__containt .page__table .table-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }
  .accountant {
    display: flex;
    justify-content: space-evenly;
    margin-top: 5%;
    text-align: center;
    align-items: center;
  }
  .accountant h1 {
    font-size: 80px;
  }
  .report {
    display: flex;
  }
  .simple_table {
    width: 40%;
  }
        .body__sidebar.open{
    display: none;
  }
  /* INICIO MOBILE*/
  @media (max-width: 768px){
    .body__containt .page__title h2{
      font-size: 21px;
    }
    .body__containt .page__filters input{
      padding: 5px 20px;
      font-size: 16px;

    }

    .body__containt .page__filters input:first-child{
      width: 48.5% !important;
      font-size: 14px;
    }
    .body__containt .page__filters input:nth-child(2){
      width: 48.5% !important;
      font-size: 14px;
      margin-left: -11px;

    }
    .body__containt .page__filters .input input{
      width: 76.5% !important;
    }
    .body label:nth-child(2) {
      padding-right: 21% !important;
      margin-left: 61px;
    }
    .page__filters select{
      padding: 10px 19px;
    }
    .body label{
      margin-top: 2rem;
      margin-left: 18px;
      font-size: 13px;
    }
    .body p.clean_filter{
      margin-top: 7px;
      font-size: 14px;

    }
    .buttonExport{
      margin-top: -13px;
      width: 179px;
      padding: 9px 20px;
    }
    .body__containt .page__table{
      font-size: 11px;
    }
    .body__containt .page__table .table-headers{
      margin-top: 6px;
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
    /*ESTILO PARA SIDEBAR*/
    .body__containt .page__table .table-body{
      width: 245%;
    }
    .body__sidebar .title__text h2 {
      font-size: 18px;
    }
    .body__sidebar .title__text {
      margin: 0 10px;
      font-size: 16px;
    }
    .body__sidebar .title__icon{

      font-size: 16px;
      margin-left: 6px;
    }
    .body__sidebar .tabs .tab__icon svg{
      font-size: 15px;
      margin-right: 7px;}
    .body__sidebar .tabs .a{
      margin-left: -2px;
      margin-top: -1px;
    }
    .body__sidebar a svg{
      font-size: 22px;
    }
    .body__sidebar .tabs .tab__text p {

      margin-left: -8px;
    }
    /*BARRA LATERAL IZQUIERDA MOBILE*/
    .body__sidebar .tabs .tab__icon {
      color: white;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
      color: #ff3128;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
      color: #ff3128;
      font-size: 20px;
    }
    .body__sidebar .tabs .tab__text p {
      margin-left: -8px;
      color: white;
      font-size: 18px;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
      background: #262626;
      margin-bottom: -11px;
    }
    .body__containt .page__buttons .button{
      font-size: 13px;
      padding: 5px 20px;
      margin-top: -18px;
    }
    .body__containt .page__buttons {
      width: 105%;
    }
    .home .body .nav-mob-resp{
      position: absolute;
      background: #262626;
      height: 85vh;
      width: 25vh;
    }
    .body__sidebar .title {
      color: white;
    }
    .body__sidebar .floating-icon {
      position: absolute;
      right: -35px;
    }
    .body__sidebar .tabs .tab{
      margin-bottom: -7px;
    }

  }

</style>
